import {
  EXAM_COURSE_AUDIT_LOG,
  EXAMINATION_COURSE,
  LOS,
  QBANK_AUDIT_LOG,
  QBANK_DASHBOARD,
  QBANK_SETTINGS,
  QCONFIG,
  QSET,
  QSET_REVIEW_TASK,
  QUESTION,
  QUESTION_CREATION_TASK,
  QUESTION_REVIEW_TASK,
  ROLE,
  STRUCTURE,
  USER,
  USER_MANAGEMENT_AUDIT_LOG,
} from '@shared/permissions';

const APP_PERMISSIONS = {
  SETTING: {
    ROLE: ROLE,
    USER: USER,
    AUDIT_LOG: USER_MANAGEMENT_AUDIT_LOG,
  },
  QBANK: {
    DASHBOARD: QBANK_DASHBOARD,
    QUESTION: QUESTION,
    STRUCTURE: STRUCTURE,
    LOS: LOS,
    SETTING: QBANK_SETTINGS,
    AUDIT_LOG: QBANK_AUDIT_LOG,
  },
  EXAM: {
    EXAMINATION_COURSE: EXAMINATION_COURSE,
    QCONFIG: QCONFIG,
    QSET: QSET,
    AUDIT_LOG: EXAM_COURSE_AUDIT_LOG,
  },
  TASK: {
    QUESTION_CREATION: QUESTION_CREATION_TASK,
    QUESTION_REVIEW: QUESTION_REVIEW_TASK,
    QSET_REVIEW: QSET_REVIEW_TASK,
  },
};

export { APP_PERMISSIONS };
